import { Controller } from "stimulus";
import Glide from "@glidejs/glide";
import { unveilImages, unveilImage } from "init/unveil";

export default class extends Controller {
  static targets = [
    "controls",
    "innerThumbnails",
    "thumbnails"
  ];

  connect() {
    this.sliders = this.element.querySelectorAll(".glide");
    this.large_images = this.element.querySelectorAll(
        ".glide__slides [data-src]"
    );
    window.addEventListener("DOMContentLoaded", this.mount.bind(this));
  }

  mount() {
    let options = {
      // autoplay: 4000,
      type: "carousel",
      perView: 1
    };
    this.sliders.forEach(slider => this.initSlider(new Glide(slider, options)));
  }

  initSlider(slider) {
    slider.mount();

    this.element.querySelector(".controls.left").addEventListener("click", () => {
      slider.go("<");
    });

    this.element.querySelector(".controls.right").addEventListener("click", () => {
      slider.go(">");
    });

    this.setBulletsPosition();
  }

  setBulletsPosition() {
    const [firstImage] = this.element.querySelectorAll(
        ".glide__slides .glide__slide--active [data-src]"
    );

    new ResizeObserver(() => {
      const imageHeight = firstImage.clientHeight
      const [bullets] = this.element.querySelectorAll(".glide__bullets")
      if (bullets) {
        bullets.style.top = `${imageHeight - 50}px`;
      }
    }).observe(firstImage);
  }

  set(slider) {
    let index = slider.index;
    let slides = slider.selector.querySelectorAll(".glide__slide");
    let currentSlide = slides[index];
  }

  unveilImages = unveilImages;
  unveilImage = unveilImage;
}
